import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { Observable, of } from 'rxjs';

import { VIRoutingMap } from '@web/app/routing/routes';
import * as SideMenuActions from '@web/core/actions/side-menu.actions';

import { LocalStorageService } from '@common/modules/shared/services/local-storage.service';
import { FeatureSwitchService } from '@common/modules/core/services/feature-switch/feature-switch.service';
import { SideMenuOption } from '@common/modules/core/services/interfaces';

import { BaseExtensionNavigationGuard } from './base-extension-navigation.guard';

export const DefaultPathGuard: CanActivateFn = (): Observable<boolean> => {
  return inject(DefaultPathGuardService).canActivate();
};

@Injectable({
  providedIn: 'root'
})
export class DefaultPathGuardService extends BaseExtensionNavigationGuard {
  constructor(localStorageService: LocalStorageService, router: Router, store: Store, featureSwitchService: FeatureSwitchService) {
    super(localStorageService, router, store, featureSwitchService);
  }

  protected handleNoExtensionNavigation(): Observable<boolean> {
    this.redirectToMediaGallery();
    return of(true);
  }

  private redirectToMediaGallery(): void {
    this.store.dispatch(SideMenuActions.sideMenuInitOption({ option: SideMenuOption.Media }));
    this.router.navigate([`${VIRoutingMap.mediaGallery.path}`]).then(() => {
      this.onNavigationSuccess();
    });
  }
}
